import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="10" y="2" width="12" height="19" rx="6" fill="#fff" /><path stroke="#fff" strokeWidth="2" d="M16 24v4" /><path stroke="#fff" strokeWidth="2" strokeLinecap="round" d="M13 28h6M25 15a9 9 0 11-18 0" /></svg>);